import { useEffect } from "react";

/**
 * Mientras `activo`, el navegador pregunta antes de cerrar o recargar la
 * pestaña (`beforeunload`). Para operaciones largas que corren en el
 * servidor (estimar, emitir, imprimir un PDF grande, importar): si el
 * operador recarga a mitad no ve el resultado y tiende a repetirla.
 *
 * El texto del aviso lo pone el navegador; no se puede personalizar.
 */
export function useAvisoSalida(activo: boolean): void {
  useEffect(() => {
    if (!activo) return;
    const onBeforeUnload = (e: BeforeUnloadEvent): void => {
      e.preventDefault();
      // Chrome < 119 y Edge exigen returnValue para mostrar el aviso.
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [activo]);
}
